import { styled } from '@mui/material';
import Typography, { TypographyProps } from '@mui/material/Typography';

interface LimitedLinesTypographyProps extends TypographyProps {
  lines?: number;
}

const MultiLineEllipsisTypography = styled(Typography, {
  shouldForwardProp: prop => prop !== 'lines',
})<LimitedLinesTypographyProps>(({ lines = 2 }) => ({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitLineClamp: lines,
}));

function LimitedLinesTypography({
  lines = 2,
  children,
  ...props
}: LimitedLinesTypographyProps) {
  return (
    <MultiLineEllipsisTypography lines={lines} {...props}>
      {children}
    </MultiLineEllipsisTypography>
  );
}

export default LimitedLinesTypography;
